import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const SidebarItem = ({ item }) => {
    const [open, setOpen] = useState(false);

    if (item.childrens) {
        return (
            <ul className='list-none text-white'>
                <li className={`${open ? "activeItem" : ""} nav_li `} onClick={() => setOpen(!open)} >
                    <div className='flex justify-between items-baseline px-4 text-xs xsm:text-sm xsm:px-6 py-3 cursor-pointer '>
                        <span>
                            <i className={item.icon}></i>
                            <span className='ml-2'>{item.title}</span>
                        </span>
                        <i className={`fas fa-angle-down animation ${open ? "rotate-180" : ""}`}></i>
                    </div>
                </li>
                {item.childrens.map((child, index) => <li className={` ${open ? "left-0" : "-left-full visually-hidden"} bg-slate-700 animation`} key={index}> <SidebarItem item={child} /></li>)}
            </ul>
        )
    }
    else {
        if (item.title === 'Download Backup') return (
            <ul className='list-none text-white'>
                <li className='hover:bg-gray-900 animation'>
                    <a href={item.path} target='_blank' className="block py-3 px-4 xsm:px-6 text-xs xsm:text-sm" activeclassname="active" >
                        <i className={item.icon}></i>
                        <span className='ml-2'>{item.title}</span>
                    </a>
                </li>
            </ul>
        )
        return (
            <ul className='list-none text-white'>
                <li className='hover:bg-gray-900 animation'>
                    <NavLink to={item.path} className="block py-3 px-4 xsm:px-6 text-xs xsm:text-sm" activeclassname="active" >
                        <i className={item.icon}></i>
                        <span className='ml-2'>{item.title}</span>
                    </NavLink>
                </li>
            </ul>
        )
    }


}

export default SidebarItem;
